var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#linear-gradient);}.cls-2{fill:#eabb8c;}.cls-10,.cls-3{opacity:0.32;fill:url(#linear-gradient-2);}.cls-10,.cls-13,.cls-3{mix-blend-mode:multiply;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#f4c3ae;opacity:0.92;}.cls-4,.cls-7,.cls-9{mix-blend-mode:overlay;}.cls-5{isolation:isolate;}.cls-6{fill:#bf9162;}.cls-7{opacity:0.45;fill:url(#linear-gradient-3);}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#e8a77c;opacity:0.67;}.cls-11{clip-path:url(#clip-path-3);}.cls-12{clip-path:url(#clip-path-4);}.cls-13,.cls-17,.cls-20{fill:none;stroke-miterlimit:10;}.cls-13{stroke:#6d4638;stroke-width:0.32652px;opacity:0.1;}.cls-14{opacity:0.72;}.cls-15{fill:#773507;}.cls-16{fill:#763718;}.cls-17,.cls-20{stroke:#f90000;}.cls-17{stroke-width:1.26667px;}.cls-18{fill:#f90000;}.cls-19{font-size:11.76027px;font-family:Calibri-Bold,\n            Calibri;font-weight:700;}.cls-20{stroke-width:1.25178px;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.03485,
    y1: 88.63193,
    x2: 76.00862,
    y2: 88.63193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24608,
    stopColor: "#ba8c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58608,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90782,
    stopColor: "#ad7b52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 23.03485,
    y1: 47.42996,
    x2: 185.88056,
    y2: 47.42996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18378,
    stopColor: "#ba8d57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46212,
    stopColor: "#b08053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71229,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71549,
    stopColor: "#ad7a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78914,
    stopColor: "#ad5c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86195,
    stopColor: "#ad4752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93294,
    stopColor: "#ad3a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.907 29.808 185.881 65.052 76.009 65.052 23.035 29.808 132.907 29.808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 76.00862,
    y1: 106.25356,
    x2: 185.88056,
    y2: 106.25356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15143,
    stopColor: "#ba8c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36067,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55866,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594136"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.035 29.808 76.009 65.052 76.009 147.456 23.035 112.212 23.035 29.808"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.907 29.808 185.881 65.052 76.009 65.052 23.035 29.808 132.907 29.808"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "38.801 40.298 152.528 40.298 166.163 40.298 169.298 48.459 50.457 48.929 38.801 40.298"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.00862,
    y: 65.05158,
    width: 109.87194,
    height: 82.40396
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 76.00862,
    y: 65.05158,
    width: 109.87194,
    height: 82.40396
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.035 29.808 76.009 65.052 76.009 147.456 23.035 112.212 23.035 29.808"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "38.801 40.298 38.801 70.245 51.75 78.708 51.75 45.481 40.779 38.742 38.801 40.298"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.907 29.808 185.881 65.052 76.009 65.052 23.035 29.808 132.907 29.808"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "132.907 29.808 185.881 65.052 76.009 65.052 23.035 29.808 132.907 29.808"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "38.801 40.298 152.528 40.298 166.163 40.298 169.298 48.459 50.457 48.929 38.801 40.298"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 159.4801,
    y1: 43.20632,
    x2: 39.8202,
    y2: 43.20632
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M112.26957,146.10376a9.01676,9.01676,0,1,1,8.65385-9.36565A9.02692,9.02692,0,0,1,112.26957,146.10376Zm-.68316-17.29431a8.291,8.291,0,1,0,8.61185,7.95731A8.30044,8.30044,0,0,0,111.58641,128.80945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M116.39274,138.41252l.00015-.00022.05813.07019.01443-.00057c.01095-.00044.00932-.04161.00787-.06184a4.61077,4.61077,0,0,0-9.0012.34319c.00569.05835.08156-.005.08156-.005h.00005a.8639.8639,0,0,1,.6509-.28613.8515.8515,0,0,1,.68276.247.09871.09871,0,0,0,.1589-.00627.96289.96289,0,0,1,1.34391-.05309.09876.09876,0,0,0,.159-.00628.96283.96283,0,0,1,1.34385-.05308.09877.09877,0,0,0,.159-.00628.96282.96282,0,0,1,1.34385-.05309.09875.09875,0,0,0,.159-.00628.9629.9629,0,0,1,1.34391-.05308.0987.0987,0,0,0,.15889-.00628.85148.85148,0,0,1,.66115-.30006A.86035.86035,0,0,1,116.39274,138.41252Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.77605,143.624l-.00615.00024h0a.67355.67355,0,0,1-.69264-.646.36289.36289,0,0,1,.60285-.28626l-.30951-7.83535a.36286.36286,0,1,1,.72516-.02864l.31986,8.09738a.67355.67355,0,0,1-.63957.69859Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M110.9039,133.60385a.75308.75308,0,0,1-1.10623-1.02214,8.4025,8.4025,0,0,1,1.81253-.85193A8.40118,8.40118,0,0,1,110.9039,133.60385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.74672,132.7076a.75308.75308,0,0,1-1.10623-1.02214,8.40168,8.40168,0,0,1,1.81253-.85193A8.40369,8.40369,0,0,1,114.74672,132.7076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M117.12754,135.06176a.75308.75308,0,0,1-1.10622-1.02215,8.40252,8.40252,0,0,1,1.81252-.85193A8.40337,8.40337,0,0,1,117.12754,135.06176Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.18175,146.25742a8.98527,8.98527,0,1,1,8.62363-9.333A8.99543,8.99543,0,0,1,88.18175,146.25742ZM87.501,129.02351a8.26208,8.26208,0,1,0,8.58178,7.9295A8.2714,8.2714,0,0,0,87.501,129.02351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.41444,138.22484l.7968.7363a.37623.37623,0,0,0,.27162.10008l1.154-.04558.44181-1.0698a.25261.25261,0,0,1,.31189-.14367l.10262.0335a.1483.1483,0,0,0,.16951-.22311l-.86133-1.29506a.5456.5456,0,0,0-.52135-.23924l-1.394.17273a.14829.14829,0,0,0-.05274.27736.25262.25262,0,0,1,.11469.31264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M85.67244,139.57326l-2.1645.123A1.00728,1.00728,0,0,1,82.78,139.428l-.55572-.51354a.88042.88042,0,0,0,.14581.46093l1.56664,2.35535a.88213.88213,0,0,0,.77057.39288l1.115-.04568a1.25478,1.25478,0,1,0-.14991-2.50463Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.63167,133.288l-.54555,1.018.6983.923a.25256.25256,0,0,1-.03416.34167l-.08087.07152a.14828.14828,0,0,0,.10643.25916l1.5529-.08623a.54552.54552,0,0,0,.47047-.32815l.55755-1.28926a.1483.1483,0,0,0-.21235-.18606.25267.25267,0,0,1-.32763-.05951l-.92261-1.16133-1.03858.3138A.37591.37591,0,0,0,88.63167,133.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.67164,132.4963l.72435-.21883a.88058.88058,0,0,0-.47122-.10791l-2.82441.1569a.88219.88219,0,0,0-.72918.46521l-.52568.98441a1.25476,1.25476,0,1,0,2.2351,1.14008l.99089-1.92828A1.00743,1.00743,0,0,1,88.67164,132.4963Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M90.633,139.52759l-1.15726.01718a.25261.25261,0,0,1-.25532-.2296l-.00985-.10754a.14828.14828,0,0,0-.2719-.06747l-.8489,1.30327a.54548.54548,0,0,0-.0136.57342l.70989,1.21207a.14829.14829,0,0,0,.27563-.06122.2526.2526,0,0,1,.24177-.22895l1.482-.05713.36122-1.02308a.37606.37606,0,0,0-.01549-.289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.45977,138.23391l-.4829-1.00609a1.25478,1.25478,0,1,0-2.24121,1.1281l.9689,1.93944a1.00728,1.00728,0,0,1,.04142.77467l-.25193.71349a.88036.88036,0,0,0,.36572-.31618l1.54387-2.37029A.88211.88211,0,0,0,93.45977,138.23391Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137.22289,146.222a8.93012,8.93012,0,1,1,8.57069-9.27569A8.94027,8.94027,0,0,1,137.22289,146.222Zm-.6766-17.12814a8.21134,8.21134,0,1,0,8.52905,7.88082A8.22071,8.22071,0,0,0,136.54629,129.09389Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M138.81409,137.65924l2.96491-.11712-.79149-3.35181a.39147.39147,0,0,0-.39648-.30127l-5.47833.2164a.12265.12265,0,0,0-.032.23955l3.30818,1.04094a.39157.39157,0,0,1,.2728.3427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.62589,133.49211a1.07239,1.07239,0,1,0-1.11386-1.02924A1.0724,1.0724,0,0,0,139.62589,133.49211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M142.08307,142.68677l-.295-4.91391-2.9462.11638-1.54275,5.07319a.12267.12267,0,0,0,.21284.1127l2.54546-3.15635,1.71531,2.86392A.16719.16719,0,0,0,142.08307,142.68677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M135.8128,143.17574l-2.23924.08846a.7286.7286,0,0,1-.74313-.59781l-.95185-5.33693a.72571.72571,0,0,1,.68584-.85268l3.719-.1469a.72582.72582,0,0,1,.751.79583l-.52789,5.39552A.7288.7288,0,0,1,135.8128,143.17574Zm-3.22-5.98074-.00665.00823.95185,5.337.0072.00577,2.23923-.08846.00677-.00642.52789-5.39536-.00732-.00768Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.31208,143.23507a.35942.35942,0,0,1-.37038-.31458l-.75943-6.078a.35942.35942,0,0,1,.7133-.08913l.75938,6.07794a.35939.35939,0,0,1-.31207.40118Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M135.28325,143.19666q-.01238.0005-.02505.00018a.3594.3594,0,0,1-.34868-.36979l.17948-6.11505a.35939.35939,0,1,1,.71847.02107l-.17949,6.11508A.35939.35939,0,0,1,135.28325,143.19666Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.54543,138.93638l-4.03667.15946a.35938.35938,0,0,1-.02837-.71819l4.03667-.15945a.35937.35937,0,1,1,.02837.71818Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.50554,137.92584l-4.03667.15945a.35938.35938,0,0,1-.02837-.71819l4.03667-.15945a.35938.35938,0,1,1,.02837.71819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.39576,139.92136l-3.7431.14785a.3604.3604,0,0,1-.02837-.71818l3.7431-.14786a.3604.3604,0,0,1,.02837.71819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.13318,141.2196l-3.17336.12535a.35938.35938,0,1,1-.02837-.71819l3.17336-.12535a.35938.35938,0,0,1,.02837.71819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.56547,135.43283l2.04912-.50718a.12544.12544,0,0,1,.12018.20909l-.95321.98277a.12546.12546,0,0,1-.15947.01716Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M170.12132,69.39717a6.50631,6.50631,0,1,1-6.34982,6.56157A6.24218,6.24218,0,0,1,170.12132,69.39717Zm.0067.76169a5.75,5.75,0,1,0,5.533,5.69524A5.40645,5.40645,0,0,0,170.128,70.15886Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 170.15983,
    y: 81.61313,
    width: 7.65244,
    height: 0.74856,
    transform: "translate(-0.71482 1.5344) rotate(-0.50426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "177.781 82.74 179.728 81.937 177.767 81.168 177.781 82.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M165.02006,82.4573a6.50628,6.50628,0,1,1,6.34981-6.56152A6.24213,6.24213,0,0,1,165.02006,82.4573Zm-.0067-.76159a5.75,5.75,0,1,0-5.533-5.69529A5.40648,5.40648,0,0,0,165.01336,81.69571Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 157.32911,
    y: 69.49283,
    width: 7.65244,
    height: 0.74855,
    transform: "matrix(0.99996, -0.0088, 0.0088, 0.99996, -0.60865, 1.42101)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "157.36 69.114 155.413 69.918 157.374 70.686 157.36 69.114"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 185.20728,
    y1: 160.82886,
    x2: 153.31482,
    y2: 160.82886
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "180.098 157.018 180.327 165.192 186.999 161.21 180.098 157.018"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 77.69999,
    y1: 161.10483,
    x2: 113.29328,
    y2: 161.32598
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "82.81 157.295 82.768 165.138 76.527 161.055 82.81 157.295"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 68.34796,
    y1: 158.62732,
    x2: 50.93853,
    y2: 146.37985
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "66.399 152.559 61.842 159.348 69.586 159.977 66.399 152.559"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 16.20518,
    y1: 120.01679,
    x2: 34.89075,
    y2: 133.50879
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "22.578 119.879 17.992 126.243 15.279 119.295 22.578 119.879"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(120.18791 165.08425)"
  }, "60 cm"), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(193.33537 108.05984)"
  }, "45 cm"), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 200.45262,
    y1: 145.79144,
    x2: 200.26864,
    y2: 116.30281
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "204.263 140.801 196.09 141.026 200.453 147.37 204.263 140.801"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 200.03931,
    y1: 67.37758,
    x2: 200.03931,
    y2: 95.9724
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "203.85 72.487 196.006 72.446 200.039 65.363 203.85 72.487"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(27.559 143.62429)"
  }, "45 cm")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarge);
export default __webpack_public_path__ + "static/media/Large.532bf9eafd2fd538362be69e9aa7cc85.svg";
export { ForwardRef as ReactComponent };